var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.8848 28.6447C90.7696 28.4155 90.7695 28.1864 90.6543 27.9573C90.5391 27.3845 90.3086 26.8117 90.0782 26.3534C88.5802 23.3748 86.1605 22 82.7037 22H34.7695C28.2016 22 21.6337 22 15.0658 22C10.3416 22 7 25.3223 7 29.9049C7 42.5068 7 55.2233 7 67.8252V73.0951C7 74.9282 7.57613 76.532 8.61317 77.9068C10.2263 79.9689 12.4156 81 15.1811 81C32.1193 81 48.9424 81 65.8807 81H82.8189C82.9342 81 83.0494 81 83.2798 81C86.0453 80.8854 88.1193 79.7398 89.3868 77.7922C89.8477 76.9903 90.1934 76.1883 90.5391 75.3864C90.6543 75.0427 90.7696 74.699 91 74.3553V74.2408V28.7592L90.8848 28.6447ZM85.1235 31.5087V71.033L65.3045 51.5573L85.1235 31.5087ZM32.1193 51.4427L12.6461 71.1476V31.8524L32.1193 51.4427ZM43.7572 54.3068C37.1893 47.7767 30.6214 41.2466 24.0535 34.8311L16.7942 27.6136H81.0905L75.214 33.4563C68.1852 40.3301 61.0412 47.3184 54.0123 54.3068C50.9012 57.4 46.8683 57.4 43.7572 54.3068ZM36.7284 55.3379L37.4198 56.0252C38.2263 56.8272 39.0329 57.6291 39.7243 58.4311C41.4527 60.1495 43.2963 61.2951 45.3704 61.868C50.0947 63.1282 54.358 61.9825 57.93 58.5456C58.7366 57.7437 59.428 57.0563 60.2346 56.2544C60.465 56.0252 60.8107 55.6815 61.0412 55.4524L80.5144 75.1573H17.2551L36.7284 55.3379Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6bb7f71b9ad825cd25ef0d02c86b8185.svg";
export { ForwardRef as ReactComponent };